<template>
  <ImageManagement 
    folder-type="horses" 
    :page-title="$t('imageManagement.horseImages')"
    :empty-text="$t('imageManagement.noImages')"
  />
</template>

<script setup>
import ImageManagement from './index.vue'
</script>
